@for (column of columns; track column) {
  @switch (column.type) {
    @case (EnumColumnType.DATE) {
      <ng-container *ngTemplateOutlet="DateCol; context: { params: { col: column } }"></ng-container>
    }
    @case (EnumColumnType.LINK) {
      <ng-container *ngTemplateOutlet="LinkCol; context: { params: { col: column } }"></ng-container>
    }
    @case (EnumColumnType.BUTTONS) {
      <ng-container *ngTemplateOutlet="ButtonsCol; context: { params: { col: column } }"></ng-container>
    }
    @case (EnumColumnType.UPDATE_BUTTON) {
      <ng-container *ngTemplateOutlet="UpdateButtonCol; context: { params: { col: column } }"></ng-container>
    }
    @default {
      <ng-container *ngTemplateOutlet="SimpleCol; context: { params: { col: column } }"></ng-container>
    }
  }
}

<ng-template #SimpleCol let-data="params">
  <app-column-control-simple
    class="table-col"
    [row]="row"
    [column]="data.col"
    [style]="data.col.cssStyle"
  ></app-column-control-simple>
</ng-template>

<ng-template #DateCol let-data="params">
  <app-column-control-date class="table-col" [row]="row" [column]="data.col"></app-column-control-date>
</ng-template>

<ng-template #LinkCol let-data="params">
  <app-column-control-link class="table-col" [row]="row" [column]="data.col"></app-column-control-link>
</ng-template>

<ng-template #ButtonsCol let-data="params">
  @if (data.col.buttons; as buttons) {
    <div class="table-col table-col-button table-col-action">
      <button matRipple class="btn col-control-action" [matMenuTriggerFor]="menu">
        <i class="fa fa-ellipsis-v" aria-hidden="true" aria-label="menu"></i>
      </button>
      <mat-menu #menu="matMenu">
        @for (itemButton of buttons; track itemButton; let i = $index) {
          @if (showWhenPending(i)) {
            <div mat-menu-item (click)="onClick(itemButton)" [style]="itemButton.cssStyle">
              @if (itemButton.icon) {
                <i class="col-control-button-icon" [class]="itemButton.icon"></i>
              }
              {{ itemButton.translate ? (itemButton.title | cxTranslate) : itemButton.title }}
            </div>
          }
        }
      </mat-menu>
    </div>
  }
</ng-template>

<ng-template #UpdateButtonCol let-data="params">
  <app-column-control-update-button
    class="table-col"
    [row]="row"
    [column]="data.col"
  ></app-column-control-update-button>
</ng-template>
